var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.options.disTransition?'':_vm.options.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.value),expression:"value"}],staticClass:"loni-popup",style:({
             zIndex: _vm.options.zIndex,
             top: _vm.options.top
         })},[_c('div',{staticClass:"background",style:({background:_vm.options.background})}),_c('div',{ref:"popupContent",staticClass:"content",class:{
                 flex: _vm.options.flex,
                 center: _vm.options.center
             },style:({padding:_vm.options.center?0:_vm.options.padding})},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }